import { render, staticRenderFns } from "./notifyStats.vue?vue&type=template&id=d7cf84da&scoped=true&lang=pug"
import script from "./notifyStats.vue?vue&type=script&lang=js"
export * from "./notifyStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7cf84da",
  null
  
)

/* custom blocks */
import block0 from "./notifyStats.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports